import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickPaymentsState = createSelector(getOneClickState, state => state.paymentsState);

export const getOneClickPayments = createSelector(getOneClickPaymentsState, state => state.paymentsAvailable);

export const getOneClickPaymentsAt = (index: number) => {
  return createSelector(getOneClickPayments, state => {
    return state[index];
  });
};

export const getOneClickPaymentsSelected = createSelector(getOneClickPaymentsState, state => state.selected);

export const getOneClickProfileState = createSelector(getOneClickState, state => state.profileState);

export const getOneClickPreloadedOrder = createSelector(getOneClickProfileState, state => state.presetOrder);

export const getPaymentTermWithPreloadedOrder = (index: number) =>
  createSelector(getOneClickPaymentsAt(index), getOneClickPreloadedOrder, (payments, preloadedOrder) => ({
    payments,
    preloadedOrder,
  }));
